<template lang="pug">
v-dialog(v-if="showDialog" v-model="showDialog" max-width="560" persistent)
  v-card(rounded="lg")
    v-card-title.px-4
      v-spacer
      h6.ml-10 {{ $t('remove_assignee') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider.mb-6

    .px-6
      .s1 {{ $t('remove_assignee_confirmation_1') }}
      .mt-4.p1 {{ $t('remove_assignee_confirmation_2') }}
      .mt-4.p1.mb-16 {{ $t('click_confirm_to_proceed') }}
    v-divider.mb-2.mt-4

    v-card-actions.pb-4.px-6
      v-spacer
      v-btn.button-Aa-medium.px-4.primary400--text(@click="showDialog = false" text height=40) {{ $t('back') }}
      v-btn.button-Aa-medium.px-4(@click="deleteAgent" :loading="isLoading" color="danger500" depressed dark height=40) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'deleteId', 'task'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    deleteAgent () {
      this.isLoading = true
      const newIds = this.task.assign_to.map(item => item.id).filter(id => id !== this.deleteId)
      this.$axios.patch(`/connect/${this.company.slug}/tasks/${this.task.id}?expand=assign_to.user`, { assign_to: newIds })
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.assignee_removed_successfully')])
          this.$emit('deleted', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_remove_assignee')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>